export enum MessageType {
    emailMessage = 'EMAIL_MESSAGE',
    linkedinConnectionRequest = 'LINKEDIN_CONNECTION_REQUEST',
    linkedinConnectionRequestAccepted = 'LINKEDIN_CONNECTION_REQUEST_ACCEPTED',
    linkedinMessage = 'LINKEDIN_MESSAGE',
}
